import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const readByStoreChainId = async store_chain_id =>
    api
      .get(`${url.stage.storeChain}/${store_chain_id}`, {})
      .then(res => res)
      .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
    readByStoreChainId
}